import { render, staticRenderFns } from "./WebsiteChooser.vue?vue&type=template&id=22ce79d3"
import script from "./WebsiteChooser.vue?vue&type=script&lang=js"
export * from "./WebsiteChooser.vue?vue&type=script&lang=js"
import style0 from "./WebsiteChooser.vue?vue&type=style&index=0&id=22ce79d3&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports